var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2983_10767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.3279L5.63604 17.964C2.12132 14.4492 2.12132 8.75074 5.63604 5.23602C9.15076 1.7213 14.8492 1.7213 18.364 5.23602C21.8787 8.75074 21.8787 14.4492 18.364 17.964L12 24.3279ZM16.9497 16.5497C19.6834 13.8161 19.6834 9.3839 16.9497 6.65023C14.2161 3.91656 9.78392 3.91656 7.05025 6.65023C4.31658 9.3839 4.31658 13.8161 7.05025 16.5497L12 21.4995L16.9497 16.5497ZM12 13.6C10.8954 13.6 10 12.7046 10 11.6C10 10.4954 10.8954 9.59998 12 9.59998C13.1046 9.59998 14 10.4954 14 11.6C14 12.7046 13.1046 13.6 12 13.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2983_10767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.599976)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin2Line);
export default __webpack_public_path__ + "static/media/map-pin-2-line.03acefdcdc08e7f4eaf8cc95416aa30f.svg";
export { ForwardRef as ReactComponent };